import React from 'react'

//Import Banner
import banner from "../../../assets/images/contactBanner.png"

const ContactBanner = () => {
  return (
    <div className='relative'>
        <img src={banner} alt="" className='w-full'/>
        <h1 
          className='text-[#0E2A46] font-bold text-xl md:text-3xl lg:text-5xl oxygen absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
            Contact Us
        </h1>
    </div>
  )
}

export default ContactBanner